import { spacing6 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const CartLineItemWrapper = styled.div`
  display: flex;
  margin-top: ${spacing6};
`;
